import { render, staticRenderFns } from "./AuthorisationCode.vue?vue&type=template&id=fb0c0d66&scoped=true"
import script from "./AuthorisationCode.vue?vue&type=script&lang=js"
export * from "./AuthorisationCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c0d66",
  null
  
)

export default component.exports